var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeBar),expression:"closeBar"}],staticClass:"wrapper",class:{
		['background-' + _vm.pageColor]: !_vm.isScrolled && _vm.status,
		'background-aili-white': _vm.isScrolled && _vm.status,
		'pointer-events-none': !_vm.status
	}},[_c('v-text-field',{ref:"global-search-text",staticClass:"search",class:{
			closed: !_vm.status,
			['color-' + _vm.pageColor]: _vm.isScrolled
		},attrs:{"dense":"","autofocus":"","dark":!_vm.isScrolled,"color":_vm.isScrolled ? _vm.pageColor : '#fff',"value":_vm.searchText},on:{"change":_vm.onChangeSearch},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_c('div',[_c('v-icon',{staticClass:"magnify",attrs:{"color":_vm.$vuetify.breakpoint.width >= 1024 && _vm.isScrolled
							? _vm.pageColor
							: 'white'},on:{"click":_vm.onGlobalSearchClick}},[_vm._v(" mdi-magnify ")])],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }